import type { CorrectComponentType } from "/npm/@brytdesigns/web-component-utils@0.1.7";
import { type Format } from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/utils/index.js";

import { Show } from "/npm/solid-js@^1.9.5/+esm";

import {
  type ValidHybridPath,
  useFullPropertyPath,
  useFormattedValue,
} from "/npm/@brytdesigns/shopify-hybrid-cart-components@0.2.19/dist/jsdelivr/hooks/index.js";
import html from "/npm/solid-js@^1.9.5/html/+esm";

type CartDataProps = {
  propertyName: ValidHybridPath;
  format?: Format;
};

export const CartData: CorrectComponentType<CartDataProps> = (
  props,
  { element },
) => {
  if (!props.propertyName)
    return console.warn(
      "No property-name attribute provided for cart-data component.",
    );
  const fullPath = useFullPropertyPath({
    element,
    path: () => props.propertyName,
  });
  const formattedValue = useFormattedValue({
    get format() {
      return props.format;
    },
    path: fullPath,
    element,
  });

  return html`
    <${Show} when=${() => formattedValue() !== null}> ${formattedValue} <//>
  `;
};
